import { get } from '@/utils/request'
import useSWR from 'swr'
import { BanquetRound } from '@/utils/types'
import { commonSWROptions } from './useAdmin'

const fetchBanquetRounds = (match_id: string) =>
  get('users/banquet_rounds', { match_id }).then((res) => {
    if (res.ok) {
      return res.rounds ?? []
    }
    return []
  })

const fetchBanquetRound = (round_id: string) =>
  get(`users/banquet_rounds/${round_id}`).then((res) => {
    if (res.ok) {
      return res.round ?? {}
    }
    return {}
  })

export const useBanquetRounds = (match_id: string) => {
  return useSWR(match_id ? `banquet-rounds-${match_id}` : undefined, () => fetchBanquetRounds(match_id), {
    ...commonSWROptions,
    fallbackData: [],
  }) as {
    data: BanquetRound[]
    mutate: any
    isValidating: boolean
  }
}

export const useBanquetRound = (round_id: string) => {
  return useSWR(round_id ? `banquet-round-${round_id}` : undefined, () => fetchBanquetRound(round_id), {
    ...commonSWROptions,
    fallbackData: {},
  }) as {
    data: BanquetRound
    mutate: any
    isValidating: boolean
  }
}
